<template>
  <!-- 首页容器 -->
  <div>
    <l-dialog
      :show="showPwd"
      class="editPwd"
      :ischa="true"
      @cancel="showPwd=false"
      @save="subEditPwd()"
      title="修改用户密码"
    >
      <p class>请先验证旧密码</p>
      <div class="ipt">
        <span class="label">
          <span>*</span> 验证旧密码：
        </span>
        <el-input v-model="oldPwd" style="width:3rem" type="password"></el-input>
      </div>
      <p class>设置新密码</p>
      <div class="ipt">
        <span class="label">
          <span>*</span>输入新的密码：
        </span>
        <el-input v-model="newPwd" style="width:3rem" type="password"></el-input>
        <span style="color:#999999;font-size:.14rem">（密码长度不超过16位）</span>
      </div>
      <div class="ipt">
        <span class="label">
          <span>*</span>再次输入密码：
        </span>
        <el-input v-model="againNewPwd" style="width:3rem" type="password"></el-input>
        <span style="color:#999999;font-size:.14rem">（密码长度不超过16位）</span>
      </div>
    </l-dialog>
    <l-dialog
      :show="showInfo"
      class="editInfo"
      :ischa="true"
      val2="取消"
      @cancel="showInfo=false"
      @save="subEditInfo()"
      title="修改个人资料"
    >
      <div class="wrap">
        <div class="left">
          <p>用户头像</p>
          <img :src="imgurl ? imgurl : global.ip + heard" alt />
          <l-button value="上传" color="#00B7EE" @click.native="subHeard()"></l-button>
          <input accept="image/*" type="file" ref="file" @change="getFile" v-show="false" />
        </div>
        <div class="right">
          <p style="margin-bottom:.4rem">用户账号：{{info.username}}({{job[userInfo.level]}})</p>
          <div class="ipt">
            <span class="label">
              <span>*</span>姓名：
            </span>
            <el-input v-model="name" style="width:2.8rem"></el-input>
          </div>
          <div class="ipt">
            <span class="label">
              <span>*</span>年龄：
            </span>
            <el-input v-model="age" style="width:1.5rem"></el-input>
            <span class="label" style="margin-left:.2rem">
              <span>*</span>性别：
            </span>
            <el-select v-model="sex" style="width:1rem">
              <el-option label="男" value="男"></el-option>
              <el-option label="女" value="女"></el-option>
            </el-select>
          </div>
          <div class="ipt">
            <span class="label">
              <span>*</span>编号：
            </span>
            <el-input v-model="userId" @input="userId=userId.replace(/[^0-9]/g, '')" style="width:1.5rem"></el-input>
          </div>
          <p style="margin:.3rem 0">{{ userInfo.level != 0 ? '管理' : '所属' }}部门：{{info.deptname}}</p>
        </div>
      </div>
    </l-dialog>
    <l-nav-top></l-nav-top>
    <div class="box-wrap" :style="$route.path==='/evaluation'?{width:'100%'}:''">
      <div class="sidBar" v-show="$route.path!=='/evaluation'">
        <div class="bg">
          <img :src="global.ip + userInfo.avatar" alt />
          <p style="font-size:.2rem;cursor: pointer;" @click="infolog=!infolog">
            {{userInfo.nickname}}
            <i class="el-icon-caret-bottom"></i>
          </p>
          <ul class="infolog" v-show="infolog">
            <li @click="infolog=false,showInfo=true,getUserInfo()">个人资料</li>
            <li @click="infolog=false,showPwd=true">修改密码</li>
          </ul>
          <p class="rule">{{job[userInfo.level]}}账号</p>
          <l-button value="退出登录" style="width:1.45rem" @click.native="saveLogout()"></l-button>
        </div>
        <ul class="barUl">
          <li
            v-for="(item,index) in navList"
            :key="index"
            :class="activeNav==index ? 'activeNav' : ''"
            @click="handNav(item,index)"
          >
            <div class="tailor">
              <img :src="item.src" alt />
            </div>
            <p>{{item.name}}</p>
            <i class="mark" v-if="item.id == 7" v-show="consultNum > 0"></i>
          </li>
        </ul>
      </div>
      <div
        class="content"
        :style="$route.path==='/evaluation'?{width:'100%',backgroundColor:'#FFF'}:''"
      >
        <div class="bg" :style="$route.path==='/evaluation'?{width:'100%'}:''"></div>
        <div class="slot" :style="$route.path==='/evaluation'?{paddingRight:'0'}:''">
          <slot></slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import lNavTop from "../components/lNavTop.vue";
import lButton from "../components/lButton.vue";
export default {
  data() {
    return {
      userInfo: JSON.parse(localStorage.getItem("userinfo")),
      level: JSON.parse(localStorage.getItem("userinfo"))?.level,
      activeNav: 0,
      infolog: false,
      //提示
      showLogout: false,
      //修改密码
      showPwd: false,
      oldPwd: "",
      newPwd: "",
      againNewPwd: "",
      //修改个人资料
      showInfo: false,
      info: {},
      heard: "",
      imgurl: "",
      name: "",
      age: "",
      sex: "",
      userId: "",
      //
      consultNum: 0,
      job: ["普通用户", "管理员", "超级管理员", "专家"],
      navList: [],
      list: [
        {
          id: 1,
          name: "首页",
          src: require("../assets/img/home/1.png"),
          path: "/",
        },
        {
          id: 2,
          name: "量表测评",
          src: require("../assets/img/home/2.png"),
          path: "/scale",
        },
        {
          id: 3,
          name: "问卷测评",
          src: require("../assets/img/home/3.png"),
          path: "/question",
        },
        {
          id: 4,
          name: "普查测评",
          src: require("../assets/img/home/4.png"),
          path: "/survey",
        },
        {
          id: 5,
          name: "预警结果",
          src: require("../assets/img/home/5.png"),
          path: "/warning/list",
          auth: "admin",
        },
        {
          id: 9,
          name: "互动测评",
          src: require("../assets/img/home/9.png"),
          path: "/interaction",
          auth: "admin",
        },
        {
          id: 7,
          name: "专家咨询",
          src: require("../assets/img/home/7.png"),
          path: "/counselorConsult",
        },
        {
          id: 8,
          name: "录入测评结果",
          src: require("../assets/img/home/8.png"),
          path: "/enteringAppraisalResult",
          auth: "admin",
        },
        {
          id: 6,
          name: "用户管理",
          src: require("../assets/img/home/6.png"),
          path: "/userAdmin",
          auth: "admin",
        },
        {
          id: 10,
          name: "系统设置",
          src: require("../assets/img/home/10.png"),
          path: "/setting",
        },

        // {
        //   id: 11,
        //   name: "心理自助",
        //   src: require("../assets/img/home/9.png"),
        //   path: "/relax",
        // },
      ],
    };
  },
  mounted() {
    this.navList = this.list.filter((item) => {
      if (this.level == 1 || this.level == 2) {
        return item;
      } else {
        return item.auth != "admin";
      }
    });
    this.navList.forEach((item, index) => {
      if (this.$route.path.indexOf(item.path) !== -1 && item.path !== "") {
        this.activeNav = index;
      }
    });
    this.getConsultNum()
    window.upDataHomeConsultNum = this.getConsultNum
  },
  methods: {
    handNav(item, index) {
      this.activeNav = index;
      this.$router.push(item.path);
    },
    //获取个人资料
    async getUserInfo() {
      let { data } = await this.$post("api/index/userInfo", {
        status: 1,
      });
      this.info = data.data.list;
      this.name = this.info.nickname;
      this.age = this.info.age;
      this.sex = this.info.sex;
      this.userId = this.info.studentId;
      this.heard = this.info.avatar;
    },
    //修改个人资料
    async subEditInfo() {
      if (!this.name) {
        this.$myMessage("姓名不能为空");
        return
      }
      if (!this.age) {
        this.$myMessage("年龄不能为空");
        return
      }
      if (!this.sex) {
        this.$myMessage("性别不能为空");
        return
      }
      if (!this.userId) {
        this.$myMessage("编号不能为空");
        return
      }
      let { data } = await this.$post("api/index/userInfo", {
        status: 3,
        avatar: this.imgurl,
        nickname: this.name,
        age: this.age,
        sex: this.sex,
        studentId: this.userId,
      });
      if (data.code == 0) {
        localStorage.setItem("userinfo", JSON.stringify(data.data.list));
        this.userInfo = JSON.parse(localStorage.getItem("userinfo"));
        this.showInfo = false;
      }
    },
    //退出登录
    saveLogout() {
      this.$popup({
        title: '提示',
        content: '是否退出登录？',
        saveFoo: () => {
          this.$post("api/index/logout").then((res) => {
            localStorage.removeItem("userinfo");
            this.$router.push("/login");
          });
        },
      })
    },
    //上传头像
    subHeard() {
      this.$refs.file.click();
    },
    getFile(e) {
      let $target = e.target || e.srcElement;
      let file = $target.files[0];
      var reader = new FileReader();
      var _this = this;
      reader.onload = function (data) {
        let res = data.target || data.srcElement;
        let imgurl = res.result;
        _this.imgurl = imgurl;
      };
      reader.readAsDataURL(file);
    },
    //修改密码
    async subEditPwd() {
      if (!this.newPwd || !this.againNewPwd || !this.oldPwd) {
        this.$myMessage("请输入必填项");
        return;
      } else if (this.newPwd != this.againNewPwd) {
        this.$myMessage("两次新密码不一致!");
        return;
      }
      await this.$post("api/index/userInfo", {
        status: 2,
        oldpwd: this.oldPwd,
        pwd: this.newPwd,
        repwd: this.againNewPwd,
      }).then((res)=>{
        if (res.data.code == '0') {
          this.newPwd = "";
          this.againNewPwd = "";
          this.oldPwd = "";
          this.showPwd = false;
          localStorage.removeItem("userinfo");
          this.$router.push("/login");
          this.$myMessage("密码修改成功，请重新登录！", 2000);
        }
      })
    },

    switchHandleDocument() {
      if (this.infolog) {
        setTimeout(() => {
          document.addEventListener('click', this.handleDocumentClick, false);
        }, 0);
      } else {
        document.removeEventListener('click', this.handleDocumentClick, false);
      }
    },
    handleDocumentClick() {
      this.infolog = false
      document.removeEventListener('click', this.handleDocumentClick, false);
    },

    getConsultNum(foo) {
      if (this.level == 0 || this.level == 3) {
        this.$post("api/expert/noReadStatic", {
        }, { noStopRepeat: true, }).then(({data})=>{
          this.consultNum = data.data.noRead.total
          if (foo) {
            foo(data)
          }
        })
      }
    },
  },
  watch: {
    infolog(newV) {
      this.switchHandleDocument()
    },
  },
  destroyed() {
    document.removeEventListener('click', this.handleDocumentClick, false);
  },
  components: {
    "l-nav-top": lNavTop,
    "l-button": lButton,
  },
};
</script>

<style lang="less" scoped>
.editPwd {
  /deep/ .dialog {
    width: 800px;
    height: 500px;
  }
  /deep/ .content {
    padding: 50px 0 0 140px;
    color: #333333;
    .el-input__inner {
      border: 0;
      background: #F0F0F0;
    }
    .ipt {
      margin: 30px 0;
      .label {
        display: inline-block;
        width: 130px;
        span {
          color: red;
        }
      }
    }
    .btn {
      margin-left: -140px;
    }
  }
}
.editInfo {
  /deep/ .dialog {
    width: 800px;
    height: 500px;
  }
  .wrap {
    display: flex;
    padding-top: 50px;
    .btn {
      background: #FFFFFF;
      line-height: 0 !important;
    }
    .left {
      width: 95px;
      margin: 0 85px 0 104px;
      text-align: center;
      color: #333333;
      img {
        width: 95px;
        height: 95px;
        margin: 33px 0 14px 0;
        border-radius: 50%;
      }
    }
    .right {
      color: #333333;
      /deep/.el-input__inner {
        border: 0;
        background: #F0F0F0;
      }
      .ipt {
        margin-bottom: 20px;
        .label {
          display: inline-block;
          width: 60px;
          span {
            color: red;
          }
        }
      }
    }
  }
}
.box-wrap {
  display: flex;
  width: 100%;
  height: 100%;
  .sidBar {
    z-index: 99;
    width: 380px;
    height: 1040px;
    background: #F0F0F0;
    box-shadow: 0 0 10px 0 rgba(0, 0, 0, .3);
    .bg {
      position: relative;
      height: 330px;
      text-align: center;
      color: #FFFFFF;
      background: #3831FF;
      img {
        width: 98px;
        height: 98px;
        margin: 48px 0 18px 0;
        border: 4px solid #00b7ee;
        border-radius: 50%;
        // background-color: #e8e8e8a0;
        background-color: #f0f0f0;
      }
      .rule {
        margin: 8px 0 24px 0;
        opacity: .5;
        font-size: 14px;
      }
      .infolog {
        position: absolute;
        top: 210px;
        left: 85px;
        overflow: hidden;
        width: 200px;
        border-radius: 6px;
        background: rgba(255, 255, 255, .95);
        li {
          height: 60px;
          color: #333333;
          border-bottom: 1px solid #DCDCDC;
          line-height: 60px;
          cursor: pointer;
          &:hover {
            background: rgba(220, 220, 255, .95);
          }
        }
      }
    }
    .barUl {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      margin-top: 20px;
      padding: 0 55px;
      color: #333333;
      .activeNav {
        color: #FFFFFF !important;
        background: #3831FF;
        img {
          transform: translateX(0) !important;
        }
      }
      li {
        position: relative;
        width: 125px;
        height: 125px;
        margin-bottom: 10px;
        list-style: none;
        text-align: center;
        border-radius: 10px;
        cursor: pointer;
        .tailor {
          overflow: hidden;
          width: 28px;
          height: 28px;
          margin: 30px auto 17px auto;
          img {
            height: 28px;
            transform: translateX(-28px);
          }
        }
        .mark {
          position: absolute;
          right: 35px;
          top: 25px;
          width: 8px;
          height: 8px;
          background: #ff0000;
          border-radius: 50%;
        }
      }
    }
  }
  .content {
    width: 1540px;
    height: 1040px;
    background: #F0F0F0;
    .bg {
      position: absolute;
      width: 1540px;
      height: 330px;
      background: #3831FF;
    }
    .slot {
      position: relative;
      box-sizing: border-box;
      width: 100%;
      height: 100%;
      padding: 49px 55px 0 55px;
    }
  }
}

</style>
